export default "__VITE_PUBLIC_ASSET__6729665f__"